import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-gas-meter',
  template: `
    <ng-template #modalGasMeter let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Medidor de gas</h5>
        <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
        <app-form-gas-meter 
          [unit_id]="unit.id" 
          [meter]="meter" 
          [saving]="saving"
          (updateMeter)="updateGasMeter($event)" 
          (createMeter)="createGasMeter($event)" 
          (cancelMeter)="cancel()"
        ></app-form-gas-meter>
      </div>
    </ng-template>
  `,
  styleUrls: []
})
export class ModalGasMeterComponent implements OnInit {
  @Input() unit: any = {};
  @Input() meter: any = {};
  @Output() updateGMeter = new EventEmitter<any>();
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalGasMeter') modalGasMeter !: ElementRef;
  
  private modalRef: NgbModalRef | undefined;
  saving = false;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    // console.log('UNIT ==========> ', this.unit)
  }

  createGasMeter(meter: any) {
    // console.log('createGasMeter', meter);
    this.updateGMeter.emit(meter);

    this.store.createGasMeter(meter).subscribe({
      next: (data: any) => {
        this.toastr.success('Medidor se creó correctamente.', 'Éxito');
        this.dismiss();
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error(`Medidor no pudo ser creado. \n ${err.error.exception}`, 'Error');
      }
    });
  }

  public updateGasMeter(meter: any) {
    if (this.saving) {
      return;
    }
    this.saving = true;
    this.store.updateGasMeter(meter.id, meter).subscribe({
      next: (data: any) => {
        this.saving = false;
        this.toastr.success('Medidor actualizado correctamente.', 'Éxito');
        this.dismiss();
      },
      error: (err: any) => {
        this.saving = false;
        this.toastr.error('No se pudo actualizar el medidor. Intenta de nuevo.', 'Error');
      }
    });
  }

  cancel() {}

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent, { backdrop: 'static' });
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
